import { apiToForm } from './apiToForm/apiToForm.ts';
import { formToApi } from './formToApi/formToApi.ts';

export const incompleteEventMapper = {
  apiToForm,
  formToApi,
};
